import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["theme", "system", "size", "compact", "lang", "type", "classes", "namespace"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { ButtonBase } from "../internal/ButtonBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import { langs, mapIcons, systems, types } from './constants';
import styles from './PaymentButton.css';
var cx = classNames.bind(styles);

var getIcon = function getIcon(_ref) {
  var system = _ref.system,
      size = _ref.size,
      compact = _ref.compact,
      lang = _ref.lang,
      type = _ref.type;

  if (system === systems.google) {
    return types.payment === type && compact ? mapIcons[system][type][size].compact : mapIcons[system][type][size][lang];
  }

  if (system === systems.dolyame) {
    return mapIcons[system].payment[size][lang][compact ? 'compact' : 'base'];
  }

  if (type === types.payment) {
    return compact ? mapIcons[system][type][size].compact : mapIcons[system][type][size][lang];
  }

  return mapIcons[system][type][size][lang][compact ? 'compact' : 'base'];
};

var SUPPORTED_LANGS = new Set([langs.en, langs.ru]);
export var PaymentButton = /*#__PURE__*/forwardRef(function PaymentButton(_ref2, ref) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'black' : _ref2$theme,
      _ref2$system = _ref2.system,
      system = _ref2$system === void 0 ? 'google' : _ref2$system,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'lg' : _ref2$size,
      _ref2$compact = _ref2.compact,
      compact = _ref2$compact === void 0 ? false : _ref2$compact,
      _ref2$lang = _ref2.lang,
      lang = _ref2$lang === void 0 ? 'ru' : _ref2$lang,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'payment' : _ref2$type,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? {} : _ref2$classes,
      namespace = _ref2.namespace,
      props = _objectWithoutProperties(_ref2, _excluded);

  var currentLang = SUPPORTED_LANGS.has(lang) ? lang : langs.en;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'paymentButton'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, props, getTestId(), {
    ref: ref,
    className: cx('root', "theme_".concat(theme), "type_".concat(type), "system_".concat(system), "size_".concat(size), "lang_".concat(currentLang), {
      compact: compact
    }, classes.root)
  }), getIcon({
    system: system,
    size: size,
    compact: compact,
    lang: currentLang,
    type: type
  }));
});